import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {

  constructor() { }

  setItem(Key, value) {
    localStorage.setItem(Key, value);
  }
  getItem(Key) {


    return localStorage.getItem(Key);
  }
  removeItem(key) {
    return localStorage.removeItem(key);
  }
  clearAll() {
    return localStorage.clear();
  }


}
